export enum DirectoryCompanionVariant {
  CONTROL = 'control',
  FIND_MY_FIT = 'find-my-fit',
  CHAT_OPEN = 'chat-open'
}

/**
 * The variants that render an AI-connect companion entry point (i.e. everything
 * except the control). Single source of truth for the "is this an AI-connect
 * variant" check so callers don't hand-maintain the membership list.
 */
export function isAiConnectCompanionVariant(
  variant: DirectoryCompanionVariant | undefined | null
): boolean {
  return variant === DirectoryCompanionVariant.FIND_MY_FIT
    || variant === DirectoryCompanionVariant.CHAT_OPEN;
}

/**
 * Variants for the standalone "guided" adaptive-intake experiment
 * (PROVIDER_DIRECTORY_GUIDED_EXPERIENCE). Separate from DirectoryCompanionVariant
 * because it is its own Amplitude experiment/flag, mutually exclusive with ai-connect
 * and OPC via an Amplitude exclusion group. Keys are an Amplitude contract.
 */
export enum GuidedExperienceVariant {
  CONTROL = 'control',
  GUIDED = 'guided'
}
